import {$http,appConst} from '@/lib'
import {Store,Module,ActionContext} from 'vuex' 

class AttachmentStore implements Module<any,any>{
    namespaced=true;
    state={
    }
    actions={
        async preViewFile(state: any, payload: any) {
            let response = await $http.get(appConst.uploadUrl.previewAction + '?id=' + payload.data.id,{responseType:"blob"});
            return response
        },

        async deleteFile(state: any, payload: any) {
            await $http.delete(appConst.uploadUrl.deleteAction+'?id=' + payload.data.id);
        },

        async exportExcel(state: any, payload: any) {
            let response = await $http.get(payload.data.url, { params: payload.data.pageRequest, responseType:"blob"  });
            return response
        },

        async downloadImportTemplate(state:any, payload:any){
            let response = await $http.get(payload.data,{responseType:"blob"});
            return response
        }
    }
}
const attachment=new AttachmentStore();
export default attachment;